/* "Zamów na jutro" countdown bar (Pat 1.10; Aleksandra's mock-up "Batida_podglad_zegar_zamow_na_jutro_v3", 1.10 late):
   sections/batida-v7-collection-head.liquid (setting cd_collection), under the facts.
   - State 1 (pink, pulsing dot): "TIK-TAK, JUTRO TUŻ-TUŻ" + "zamów w ciągu HH:MM:SS", ticking every second, until the last
     moment tomorrow can still be booked: the latest such moment over the pickup boutiques from Batida Connect's real calendar
     (the collection's first 24h product and its tags; tomorrow's last regular slot minus the preparation hours), never later
     than the cut-off setting (cd_cutoff, 21:00). Warsaw time from Intl, not the device's time zone.
   - State 2 (white, raspberry label): "ZAMÓWIENIA NA JUTRO ZAMKNIĘTE" + "najbliższy termin: <first pickup day>" (Connect skips
     Sundays and closed days). Connect is asked again when the deadline passes and at midnight (state 1 comes back).
   - State 2 also shows one plain line under the bar (setting cd_closed_n, Aleksandra 17.10: the delivery platforms, no links).
   - The bar is a same-height skeleton until Connect answers; no answer within 6 s (or nothing to show) = the facts alone.
     The last answer is kept 5 min per tab (sessionStorage). */
(function () {
  var root = document.querySelector('[data-v7c-cd]');
  if (!root || !window.fetch || !window.Intl) return;
  var API = (window.BatidaConnect && window.BatidaConnect.api) || '/apps/connect/';
  var pid = +root.getAttribute('data-pid'), tags = [];
  try { tags = JSON.parse(root.getAttribute('data-tags') || '[]'); } catch (e) {}
  var T = function (k) { return root.getAttribute('data-t-' + k) || ''; };
  var DAYS = T('days').split(',');
  var en = (root.getAttribute('data-locale') || 'pl') === 'en';

  /* ---------- Warsaw time ---------- */
  var FMT = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Warsaw', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' });
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function wParts(d) {
    var o = {}; FMT.formatToParts(d).forEach(function (x) { o[x.type] = x.value; });
    var h = +o.hour === 24 ? 0 : +o.hour;
    return { y: +o.year, m: +o.month, d: +o.day, h: h, mi: +o.minute, s: +o.second, ymd: o.year + '-' + o.month + '-' + o.day, hm: pad(h) + ':' + o.minute };
  }
  function wInstant(ymd, hm) {
    var a = ymd.split('-').map(Number), b = String(hm || '00:00').split(':').map(Number);
    var guess = Date.UTC(a[0], a[1] - 1, a[2], b[0] || 0, b[1] || 0), t = guess;
    for (var i = 0; i < 2; i++) { var p = wParts(new Date(t)); t = guess - (Date.UTC(p.y, p.m - 1, p.d, p.h, p.mi, p.s) - t); }
    return t;
  }
  function ymdUTC(ymd) { var a = ymd.split('-').map(Number); return Date.UTC(a[0], a[1] - 1, a[2]); }
  function addDays(ymd, n) { return new Date(ymdUTC(ymd) + n * 864e5).toISOString().slice(0, 10); }
  function dayName(ymd) { var a = ymd.split('-'); return (DAYS[new Date(ymdUTC(ymd)).getUTCDay()] || '') + ' ' + (+a[2]) + '.' + a[1]; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function fill(t, o) { return t.replace(/\{(\w+)\}/g, function (m, k) { return o[k] != null ? o[k] : m; }); }

  /* ---------- Connect ---------- */
  function call(path, body) {
    var opt = body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } };
    function go(base, cred) { opt.credentials = cred ? 'same-origin' : 'omit'; return fetch(base + path, opt).then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); }); }
    return go(API).catch(function () { return go('/apps/connect/', true); });
  }
  var items = [{ productId: pid, quantity: 1, tags: tags, collections: [] }];
  var locs = null;

  function load() {
    if (!locs) { try { locs = JSON.parse(sessionStorage.getItem('v7c-cd:locs') || 'null'); } catch (e) {} }
    var cfg = locs ? Promise.resolve(locs) : call('config?locale=' + (en ? 'en' : 'pl')).then(function (c) { locs = (c && c.pickup || []).map(function (l) { return l.id; }); try { sessionStorage.setItem('v7c-cd:locs', JSON.stringify(locs)); } catch (e) {} return locs; });
    return cfg.then(function (ids) {
      var jobs = ids.map(function (id) { return call('availability', { method: 'pickup', locationId: id, items: items, days: 14 }).catch(function () { return null; }); });
      jobs.push(call('availability', { method: 'delivery', postcode: '00-065', items: items, days: 14 }).catch(function () { return null; }));
      return Promise.all(jobs);
    }).then(function (res) {
      var now = Date.now(), today = wParts(new Date(now)).ymd, tomorrow = addDays(today, 1);
      var pick = null, deliv = null, first = null;
      res.forEach(function (r, i) {
        if (!r || !r.eligible || !Array.isArray(r.days)) return;
        var prep = (Number(r.prepHours) || 24) * 36e5, isDel = i === res.length - 1;
        r.days.forEach(function (d) {
          var slots = (d.slots || []).filter(function (s) { return s.from && !s.feeGrosze; });
          if (!slots.length) return;
          if (!isDel && (!first || d.date < first)) first = d.date;
          if (d.date !== tomorrow) return;
          var last = slots.reduce(function (m, s) { return s.from > m ? s.from : m; }, '00:00');
          var cut = wInstant(d.date, last) - prep;
          if (cut <= now) return;
          if (isDel) deliv = Math.max(deliv || 0, cut); else pick = Math.max(pick || 0, cut);
        });
      });
      return { pick: pick, deliv: deliv, first: first, tomorrow: tomorrow, today: today };
    });
  }

  var st = null;
  var CUT = (root.getAttribute('data-cut') || '21:00').trim();
  function hms(ms) { var t = Math.max(0, Math.floor(ms / 1000)); return pad(Math.floor(t / 3600)) + ':' + pad(Math.floor(t / 60) % 60) + ':' + pad(t % 60); }
  function deadline() {
    if (!st || !st.pick) return 0;
    var cap = /^\d{1,2}:\d{2}$/.test(CUT) ? wInstant(st.today || wParts(new Date()).ymd, CUT) : Infinity;
    return Math.min(st.pick, cap);
  }
  var bar = root.querySelector('.v7c-cdp'), shown = '';
  function render() {
    if (!st) return;
    var now = Date.now(), dl = deadline();
    if (st.today && wParts(new Date(now)).ymd !== st.today) { refresh(); return; }   // midnight: a new "tomorrow"
    if (st.pick && dl <= now) { st.pick = 0; refresh(); }                              // too late for tomorrow: ask again (state 2 meanwhile)
    var html, mode;
    if (dl > now) {
      mode = 'open';
      if (shown === 'open') { var c = bar.querySelector('.v7c-cdp__c'); if (c) c.textContent = hms(dl - now); return; }
      html = '<span class="v7c-cdp__dot" aria-hidden="true"></span><span class="v7c-cdp__k">' + esc(T('open-k')) + '</span>' +
        '<span class="v7c-cdp__t">' + esc(T('open-t')) + ' <b class="v7c-cdp__c">' + hms(dl - now) + '</b></span>';
    } else if (st.first) {
      mode = 'closed:' + st.first;
      if (shown === mode) return;
      html = '<span class="v7c-cdp__k">' + esc(T('closed-k')) + '</span><span class="v7c-cdp__t">' + esc(T('closed-t')) + ' <b>' + esc(dayName(st.first)) + '</b></span>';
    } else { facts(); return; }                      // nothing known: the facts alone
    if (!bar) { bar = document.createElement('div'); bar.className = 'v7c-cdp'; root.appendChild(bar); }
    bar.innerHTML = html;
    bar.className = 'v7c-cdp ' + (mode === 'open' ? 'is-open' : 'is-closed');
    bar.setAttribute('aria-live', 'off');            // the counter changes every second: never read out
    bar.removeAttribute('role'); bar.removeAttribute('aria-busy');
    bar.hidden = false;                              // 1.10 (Sol audit J-04): a late answer after the 6 s fallback shows the bar again
    shown = mode === 'open' ? 'open' : mode;
    note(mode !== 'open');
    root.classList.add('is-cd');
    root.classList.remove('is-loading');
  }
  /* 21.10 (Aleksandra 17.10): under the closed bar one plain line (setting cd_closed_n, no links, empty = none) */
  var noteEl = null;
  function note(on) {
    var t = T('closed-n');
    if (!t && !noteEl) return;
    if (!noteEl) { noteEl = document.createElement('p'); noteEl.className = 'v7c-cdn'; noteEl.textContent = t; root.appendChild(noteEl); }
    noteEl.hidden = !(on && t);
  }
  /* fallback: Connect not answering (or nothing to show) = the facts alone */
  function facts() { if (st && (st.pick || st.first)) return; root.classList.remove('is-cd', 'is-loading'); if (bar) bar.hidden = true; note(false); }
  /* the last answer for 5 minutes (same tab), so coming back shows the countdown at once; a fresh one follows */
  var KEY = 'v7c-cd:' + pid;
  function cacheGet() {
    try {
      var c = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      if (c && Date.now() - c.at < 3e5 && c.tomorrow === addDays(wParts(new Date()).ymd, 1)) return c;
    } catch (e) {}
    return null;
  }
  function cacheSet(r) { try { r.at = Date.now(); sessionStorage.setItem(KEY, JSON.stringify(r)); } catch (e) {} }
  var busy = false;
  function refresh() {
    if (busy) return;
    busy = true;
    load().then(function (r) { st = r; busy = false; shown = ''; cacheSet(r); render(); }, function () { busy = false; facts(); });
  }
  st = cacheGet();
  if (st) render();
  refresh();
  setTimeout(function () { if (!st) facts(); }, 6000);
  setInterval(render, 1000);                       // the clock ticks every second (only the digits change)
  document.addEventListener('visibilitychange', function () { if (!document.hidden) refresh(); });
})();
